module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido7.ca5accd6.svg";